// added on 10-12-2025

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    console.log("TOKEN RECEIVED FROM COMMON MODULE:", token);

    if (!token) {
      navigate("/");
      return;
    }
    // 🔥 CLEAR OLD SESSION (candidate or recruiter)
    //localStorage.clear(); // added on 10-12-2025
    
    localStorage.setItem("access_token", token);

    // decode token
    const payload = JSON.parse(atob(token.split(".")[1]));
    const userId = payload.user_id;

    // Check if role exists
    axios
      .get("https://stridenext.in/auth/check-role", {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        if (!res.data.hasRole) {
          // First signup → No role selected yet
          navigate("/role-selection");
        } else {
          // Existing user → Redirect to dashboard
          if (res.data.role === "candidate") navigate("/candidate-dashboard");
          else if (res.data.role === "recruiter") navigate("/recruiter-dashboard");
        }
      })
      .catch((err) => {
        console.error("ROLE CHECK FAILED", err);
        navigate("/role-selection"); // fallback
      });
  }, [navigate]);

  return <div>Authenticating...</div>;
};

export default AuthCallback; 


// added on 10-12-2025

{/*import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    console.log("TOKEN RECEIVED FROM COMMON MODULE:", token);

    if (!token) {
      navigate("/");
      return;
    }

    // 🔥 CLEAR ALL OLD SESSION (candidate or recruiter)
    localStorage.removeItem("candidate_token");
    localStorage.removeItem("recruiter_token");
    localStorage.removeItem("candidate_role");
    localStorage.removeItem("recruiter_role");

    // decode user info
    const payload = JSON.parse(atob(token.split(".")[1]));
    const userId = payload.user_id;

    // Check user role
    axios
      .get("http://localhost:8001/auth/check-role", {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        const role = res.data.role;
        const hasRole = res.data.hasRole;

        if (!hasRole) {
          navigate("/role-selection");
          return;
        }

        // -------------------------------------------
        // ⭐ FIXED — store tokens separately by role
        // -------------------------------------------
        if (role === "candidate") {
          localStorage.setItem("candidate_token", token);
          localStorage.setItem("candidate_role", "candidate");
          navigate("/candidate-dashboard");
          return;
        }

        if (role === "recruiter") {
          localStorage.setItem("recruiter_token", token);
          localStorage.setItem("recruiter_role", "recruiter");
          navigate("/recruiter-dashboard");
          return;
        }

      })
      .catch((err) => {
        console.error("ROLE CHECK FAILED", err);
        navigate("/role-selection");
      });
  }, [navigate]);

  return <div>Authenticating...</div>;
};

export default AuthCallback;
*/}

